import { Layer, Source } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { TRAFFIC_LAYER_STYLE } from '../../../../constants/map';
import { showTrafficLayerState } from '../../../../storage/map';

export function TrafficLayer() {
  const showTrafficLayer = useRecoilValue(showTrafficLayerState);

  if (!showTrafficLayer) {
    return null;
  }

  return (
    <Source
      type="vector"
      url="mapbox://mapbox.mapbox-traffic-v1"
    >
      <Layer {...TRAFFIC_LAYER_STYLE} />
    </Source>
  );
}
